import {createStore} from 'zustand/vanilla';
import type {Nullable} from '@gl/types';

export interface LoopTrackingData {
  status: number;
  goal: Nullable<number>;
}

const defaultProgressData: LoopTrackingData = {
  status: 0,
  goal: 100,
};

export interface LoopTrackerState {
  progressByAudience: Map<number, LoopTrackingData>;
  initProgressTracker: (audienceId: number, state?: LoopTrackingData) => void;
  updateProgress: (audienceId: number, newProgress: number) => void;
  resetProgress: (audienceId: number) => void;
  getProgressData: (audienceId: number) => LoopTrackingData | undefined;
}

export const loopTrackerStore = createStore<LoopTrackerState>()((set, get) => ({
  progressByAudience: new Map(),

  initProgressTracker: (audienceId: number, initState?: LoopTrackingData) => {
    set(state => ({
      progressByAudience: new Map(state.progressByAudience).set(audienceId, {
        ...defaultProgressData,
        ...initState,
      }),
    }));
  },

  updateProgress: (audienceId: number, newProgress: number) => {
    set(state => {
      const currentData = state.progressByAudience.get(audienceId);
      if (!currentData) return state;

      return {
        progressByAudience: new Map(state.progressByAudience).set(audienceId, {
          ...currentData,
          status: newProgress,
        }),
      };
    });
  },

  resetProgress: (audienceId: number) => {
    set(state => {
      const currentData = state.progressByAudience.get(audienceId);
      if (!currentData) return state;

      return {
        progressByAudience: new Map(state.progressByAudience).set(audienceId, {
          ...currentData,
          status: 0,
        }),
      };
    });
  },

  getProgressData: (audienceId: number) => {
    return get().progressByAudience.get(audienceId);
  },
}));
